import { useIdleTimeout } from '@/hooks/useIdleTimeout';
import { SessionTimeoutWarningModal } from './SessionTimeoutWarningModal';

/**
 * Runs the idle-timeout hook inside the MsalProvider context tree and renders
 * the session-expiry warning modal when the user is about to be logged out.
 */
export function IdleTimeoutHandler() {
  const { showWarning, secondsRemaining, stayLoggedIn } = useIdleTimeout();

  return (
    <SessionTimeoutWarningModal
      isOpen={showWarning}
      secondsRemaining={secondsRemaining}
      onStayLoggedIn={stayLoggedIn}
    />
  );
}
